export default __webpack_public_path__ + "dist/media/Left.20fc46d5.svg";